const DONE = new Set(["terminee", "termine"]);
const CANCELLED = new Set(["annulee", "annule"]);

export function normalizeOrderStatus(status) {
  return String(status || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

// Tout ce qui n'est ni terminé ni annulé reste dans « En cours »,
// y compris « Candidat à contacter ».
export function orderListBucket(status) {
  const raw = normalizeOrderStatus(status);
  if (DONE.has(raw)) return "Terminée";
  if (CANCELLED.has(raw)) return "Annulée";
  return "En cours";
}

export function orderStatusLabel(status) {
  const bucket = orderListBucket(status);
  const raw = String(status || "").trim();
  if (bucket !== "En cours") return bucket;
  if (!raw || normalizeOrderStatus(raw) === "en cours") return "En cours";
  return raw;
}

const EARLY_CONTACT = new Set([
  "aucun candidat",
  "candidat a contacter",
  "candidats a contacter",
]);

// Le libellé « Candidat à contacter » ne reste que s’il reste quelqu’un à proposer.
export function orderContactStatus(order, availableCount) {
  const current = String(order?.status || "").trim();
  if (!EARLY_CONTACT.has(normalizeOrderStatus(current))) return current;
  if (availableCount > 0) return "Candidat à contacter";
  if ((order?.contactedCandidates || []).length > 0) return "Candidat(s) contacté(s)";
  return "Aucun candidat";
}
